'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../components/Layout/LoginLayout.scss.js');
var Header = require('../components/Header.js');
require('../components/PopUp.scss.js');
require('../../../styles/index.scss.js');
require('../../../../node_modules/react-responsive-modal/styles.css.js');
var Button = require('../../Button/Button.js');
var index = require('../../../../node_modules/classnames/index.js');
require('../../ButtonGroup/ButtonGroup.scss.js');
require('../../Badge/Badge.scss.js');
var Checkbox = require('../../Checkbox/Checkbox.js');
require('../../Icon/Icon.scss.js');
require('../../Button/helper.scss.js');
require('../../Switch/Switch.scss.js');
var Radio = require('../../Radio/Radio.js');
var RadioGroup = require('../../RadioGroup/RadioGroup.js');
var Input = require('../../Input/Input.js');
require('../../Loader/Loader.scss.js');
require('../../Footer/Footer.scss.js');
require('../../Navbar/Navbar.js');
require('../../Navbar/MobileNavigation/styles.scss.js');
require('../../../../node_modules/pure-react-carousel/dist/index.es.js');
require('../../Carousel/Carousel.scss.js');
require('../../../../node_modules/pure-react-carousel/dist/react-carousel.es.css.js');
require('../../Pagination/Pagination.scss.js');
require('../../Modal/Modal.scss.js');
var DropDown = require('../../DropDown/DropDown.js');
require('../../Accordion/Accordion.scss.js');
require('../../Stepper/Stepper.scss.js');
require('../../Tabs/Tabs.scss.js');
require('../../BottomNavigation/FooterNavigation/Tools/Tools.scss.js');
require('../../BottomNavigation/FooterNavigation/Insurance/Insurance.scss.js');
require('../../BottomNavigation/FooterNavigation/Account/Account.scss.js');
require('../../BottomNavigation/FooterNavigation/Explore/Explore.scss.js');
require('../../BottomNavigation/FooterNavigation/FooterNavigation.scss.js');
require('../../../utils/hooks/canUseWebp.js');
require('../../BottomNavigation/BottomNavigation.scss.js');
require('../../ViewMore/ViewMore.scss.js');
require('../../Login/Login.js');
require('../index.js');
require('../../Swiper/index.js');
require('../../Alert/Alert.scss.js');
require('../../Loader/LifepalLoader.js');
require('../../SEOAccordion/SEOAccordion.scss.js');
require('../../Skeleton/index.js');
require('../../LifepalProvider/LifepalProvider.js');
require('react-dom');
require('../../../../node_modules/react-responsive-modal/node_modules/classnames/index.js');
require('../../../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js');
require('../../ResponsiveModal/style.scss.js');
var dates = require('../../../utils/dates.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var RegisterForm = function (props) {
    var errorMessage = props.errorMessage, className = props.className, back = props.back, title = props.title, onBackButtonClick = props.onBackButtonClick, onValueChange = props.onValueChange, backIcon = props.backIcon, singleError = props.singleError, hideIcon = props.hideIcon, showIcon = props.showIcon, isSubmitting = props.isSubmitting, buttonRegisterText = props.buttonRegisterText, onPolicyClick = props.onPolicyClick, onRegisterSubmit = props.onRegisterSubmit;
    var _a = React.useState(false), term = _a[0], setTerm = _a[1];
    var _b = React.useState(''), fullName = _b[0], setFullName = _b[1];
    var _c = React.useState(''), phoneNumber = _c[0], setPhoneNumber = _c[1];
    var _d = React.useState(''), password = _d[0], setPassword = _d[1];
    var _f = React.useState(false), showPassword = _f[0], setShowPassword = _f[1];
    var _g = React.useState(''), confirmPassword = _g[0], setConfirmPassword = _g[1];
    var _h = React.useState(false), showConfirmPassword = _h[0], setShowConfirmPassword = _h[1];
    var _j = React.useState(''), gender = _j[0], setGender = _j[1];
    var _k = React.useState(''), birthDay = _k[0], setBirthDay = _k[1];
    var _l = React.useState(''), birthMonth = _l[0], setBirthMonth = _l[1];
    var _m = React.useState(''), birthYear = _m[0], setBirthYear = _m[1];
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        title !== false && React__default['default'].createElement(Header.Header, { className: className && className['header'], back: back, onBackButtonClick: onBackButtonClick, backIcon: backIcon, title: title }),
        React__default['default'].createElement("div", { className: "login__forms-accounts " + ((className && className['root']) || className) },
            React__default['default'].createElement(Input.Input, { id: 'input-fullName', name: 'input-fullName', type: 'text', inputMode: 'text', value: fullName, size: 'lg', placeholder: 'Nama Lengkap', onChange: function (e) {
                    setFullName(e.target.value);
                    if (onValueChange) {
                        onValueChange();
                    }
                }, className: index['default']('login__forms-accounts-inputs__fields', {
                    'login__forms-accounts-inputs__fields-error': errorMessage && !errorMessage.fullName,
                    'login__forms-accounts-inputs__fields__errors': errorMessage && (errorMessage.fullName || (singleError && Object.keys(errorMessage).length > 0)),
                }), disabled: isSubmitting }),
            errorMessage && errorMessage.fullName &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.fullName),
            React__default['default'].createElement("div", { className: "login__forms-accounts-inputs__radio " + (errorMessage && errorMessage.gender && 'normal') },
                React__default['default'].createElement("label", { htmlFor: 'gender', className: 'gender__label' }, "Jenis Kelamin"),
                React__default['default'].createElement(RadioGroup.RadioGroup, { id: 'select-gender', groupAlignment: 'horizontal' },
                    React__default['default'].createElement(Radio.Radio, { id: 'gender', name: 'gender', labelName: 'Pria', value: 'MALE', isChecked: gender === 'MALE' ? true : false, handleOnChange: function (_e, name, value) {
                            setGender(value);
                            if (onValueChange) {
                                onValueChange();
                            }
                        } }),
                    React__default['default'].createElement(Radio.Radio, { id: 'gender', name: 'gender', labelName: 'Wanita', value: 'FEMALE', isChecked: gender === 'FEMALE' ? true : false, handleOnChange: function (_e, name, value) {
                            setGender(value);
                            if (onValueChange) {
                                onValueChange();
                            }
                        } }))),
            errorMessage && errorMessage.gender &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.gender),
            React__default['default'].createElement("div", { className: "login__forms-accounts-inputs__radio " + (errorMessage && (errorMessage.birthDay || errorMessage.birthMonth || errorMessage.birthYear) && 'normal') },
                React__default['default'].createElement("label", { className: 'gender__label' }, "Tanggal Lahir"),
                React__default['default'].createElement("div", { className: 'date' },
                    React__default['default'].createElement(DropDown.DropDown, { id: 'birthDay', name: 'birthDay', list: dates.dateList, defaultValue: birthDay, placeholder: 'Tanggal', onChange: function (e) {
                            setBirthDay(e);
                            if (onValueChange) {
                                onValueChange();
                            }
                        } }),
                    React__default['default'].createElement(DropDown.DropDown, { id: 'birthMonth', name: 'birthMonth', list: dates.monthList, defaultValue: birthMonth, placeholder: 'Bulan', onChange: function (e) {
                            setBirthMonth(e);
                            if (onValueChange) {
                                onValueChange();
                            }
                        } }),
                    React__default['default'].createElement(DropDown.DropDown, { id: 'birthYear', name: 'birthYear', list: dates.getYearList(), defaultValue: birthYear, placeholder: 'Tahun', onChange: function (e) {
                            setBirthYear(e);
                            if (onValueChange) {
                                onValueChange();
                            }
                        } }))),
            errorMessage && (errorMessage.birthDay || errorMessage.birthMonth || errorMessage.birthYear) &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage && (errorMessage.birthDay || errorMessage.birthMonth || errorMessage.birthYear)),
            React__default['default'].createElement(Input.Input, { id: 'input-phoneNumber', name: 'input-phoneNumber', type: 'tel', inputMode: 'tel', value: phoneNumber, placeholder: 'Nomor Telepon', size: 'lg', onChange: function (e) {
                    setPhoneNumber(e.target.value);
                    if (onValueChange) {
                        onValueChange();
                    }
                }, className: index['default']('login__forms-accounts-inputs__fields', {
                    'login__forms-accounts-inputs__fields-error': errorMessage && !errorMessage.phoneNumber,
                    'login__forms-accounts-inputs__fields__errors': errorMessage && (errorMessage.phoneNumber || (singleError && Object.keys(errorMessage).length > 0)),
                }), disabled: isSubmitting }),
            errorMessage && errorMessage.phoneNumber &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.phoneNumber),
            React__default['default'].createElement("div", { className: "login__forms-accounts-inputs__password-register " + (errorMessage && errorMessage.password && 'normal') },
                React__default['default'].createElement(Input.Input, { id: 'input-password', name: 'input-password', type: showPassword ? 'text' : 'password', inputMode: 'text', value: password, size: 'lg', placeholder: 'Password', onChange: function (e) {
                        setPassword(e.target.value);
                        if (onValueChange) {
                            onValueChange();
                        }
                    }, className: "" + (errorMessage && (errorMessage.password || (singleError && Object.keys(errorMessage).length > 0)) ? 'login__forms-accounts-inputs__fields__errors' : 'login__forms-accounts-inputs__fields-normal'), disabled: isSubmitting }),
                React__default['default'].createElement("span", { className: 'icon', onClick: function () { setShowPassword(!showPassword); } }, showPassword ? hideIcon || 'hide' : showIcon || 'show')),
            errorMessage && errorMessage.password &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.password),
            React__default['default'].createElement("div", { className: "login__forms-accounts-inputs__password-register " + (errorMessage && errorMessage.confirmPassword && 'normal') },
                React__default['default'].createElement(Input.Input, { id: 'input-confirmPassword', name: 'input-confirmPassword', type: showConfirmPassword ? 'text' : 'password', inputMode: 'text', value: confirmPassword, size: 'lg', placeholder: 'Konfirmasi Password', onChange: function (e) {
                        setConfirmPassword(e.target.value);
                        if (onValueChange) {
                            onValueChange();
                        }
                    }, className: "" + (errorMessage && (errorMessage.confirmPassword || (singleError && Object.keys(errorMessage).length > 0)) ? 'login__forms-accounts-inputs__fields__errors' : 'login__forms-accounts-inputs__fields-normal'), disabled: isSubmitting }),
                React__default['default'].createElement("span", { className: 'icon', onClick: function () { setShowConfirmPassword(!showConfirmPassword); } }, showConfirmPassword ? hideIcon || 'hide' : showIcon || 'show')),
            errorMessage && errorMessage.confirmPassword &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.confirmPassword),
            React__default['default'].createElement("div", { className: 'login__forms-accounts-inputs__term' },
                React__default['default'].createElement(Checkbox.Checkbox, { id: 'tc_checkbox', labelName: '', labelHidden: false, onChange: function () {
                        setTerm(!term);
                        if (onValueChange) {
                            onValueChange();
                        }
                    } }),
                React__default['default'].createElement("p", null,
                    "Saya setuju dengan ",
                    React__default['default'].createElement("span", { onClick: onPolicyClick }, "Kebijakan Pengunaan"),
                    "  Lifepal ")),
            React__default['default'].createElement(Button.Button, { variant: 'primary', id: 'regis-btn', type: 'submit', disabled: isSubmitting || !term, className: 'action-button bottom-16p', onClick: function () {
                    onRegisterSubmit({
                        fullName: fullName,
                        phoneNumber: phoneNumber,
                        password: password,
                        confirmPassword: confirmPassword,
                        gender: gender,
                        birthDay: birthDay,
                        birthMonth: birthMonth,
                        birthYear: birthYear
                    });
                } }, buttonRegisterText || 'Daftar'))));
};

exports.RegisterForm = RegisterForm;
//# sourceMappingURL=RegisterForm.js.map
